import React from 'react';
import PropTypes from 'prop-types';

/**
 * DistributionCenterAddress Component
 * 
 * Renders the distribution center return address when ship myself option is selected
 * 
 * @param {Object} props - Component props
 * @param {Object} props.carrier - Carrier information containing distribution center address
 * @param {Object} props.orderDetails - Order details (not used in current implementation)
 * @returns {JSX.Element|null} The distribution center address component or null if not applicable
 */
export default function DistributionCenterAddress({ carrier = {} }) {
  if (!carrier?.distributionCenterReturnAddress) {
    return null;
  }

  const { distributionCenterReturnAddress: addresses } = carrier;

  return (
    <ul className="distribution-center-address" data-testid="distribution-return-address">
      {addresses.map((address, index) => (
        <li key={`DISTRI_ADDRESS_${index + 1}`}>{address}</li>
      ))}
    </ul>
  );
}

DistributionCenterAddress.propTypes = {
  carrier: PropTypes.shape({
    distributionCenterReturnAddress: PropTypes.arrayOf(PropTypes.string),
  }),
}; 